export const backgroundHeight = 187;
export const backgroundHeightDesktop = `min(15vh, ${backgroundHeight}px)`;

export const productImageHeight = 244;
export const productImageHeightDesktop = 'min(40.4vh, 442.8px)';

export const productImageTrayOffset = 110;
export const productImageTrayOffsetDesktop = `min(16vh, ${productImageTrayOffset}px)`;

export const productImageContainerHeight =
  backgroundHeight + productImageHeight - productImageTrayOffset;
export const productImageContainerHeightDesktop = `calc(${backgroundHeightDesktop} + ${productImageHeightDesktop} - ${productImageTrayOffsetDesktop})`;
